export const QSR_ORDER = [
  'APPEND2',
  'CHE',
  'HERNIA',
  'sPCI-HI',
  'SPCIOHI',
  'EHTEP',
  'HEPW',
  'FRHOST',
  'FRHOST2',
  'KNIETEP',
  'KEPW',
  'BPS',
  'RPE',
]
